import { createAction, props } from "@ngrx/store";
import { WithholdingGroup } from "../../models/withholding-group";

export const findWithholdingGroupAct = createAction('findWithholdingGroupEffect', props <{ id: number }>());
export const loadWithholdingGroupByIdAct = createAction('loadWithholdingGroupByIdEffect', props<{ withholdingGroup: WithholdingGroup }>());

export const resetWithholdingGroupAct = createAction('resetWithholdingGroupEffect');

export const updateWithholdingGroupAct = createAction('updateWithholdingGroupEffect', props<{ withholdingGroupUpdated: WithholdingGroup }>());
export const updateSuccessWithholdingGroupAct = createAction('updateSuccessWithholdingGroupEffect', props<{ withholdingGroupUpdated: WithholdingGroup }>());

export const saveWithholdingGroupAct = createAction('saveWithholdingGroupEffect', props<{ withholdingGroupNew: WithholdingGroup }>());
export const saveSuccessWithholdingGroupAct = createAction('saveSuccessWithholdingGroupEffect', props<{ withholdingGroupNew: WithholdingGroup }>());

export const setViolationsWithholdingGroupAct = createAction('setViolationsWithholdingGroupEffect', props<{ withholdingGroupForm: WithholdingGroup, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
